import { LazyLoadingSectionLogger, LoggingSection } from "@multiweb/logging";
import { IAttrValue } from "@multiweb/types/contracts";
import { AttrValueReader } from "../../../../../OW.Remoting/Remoting/AttrValueReader";
import { IValidatable } from "../../../../UI.BaseControls/ControlInterfaces";
import { Edit } from "../../../../UI.BaseControls/Edit";
import { EditableControl } from "../../../../UI.BaseControls/EditableControl";
import { ElementUtils } from "../../../../UI.ElementarControls/Helpers/ElementUtils";
import { Column } from "../../Columns/Column";
import { EditItemTemplate } from "../EditItemTemplate";

const logger = LazyLoadingSectionLogger.create(LoggingSection.dataGridColumn);

export class DefaultEditTemplate extends EditItemTemplate {
    private _editElementClass: typeof EditableControl;

    constructor(editElementClass: typeof EditableControl = Edit) {
        super();
        this._editElementClass = editElementClass;
    }

    protected override _createEditElement(column: Column, dataSet: IAttrValue[], parentItem: HTMLElement): { element: HTMLElement; validatableControl: IValidatable } {
        const editableControl = new this._editElementClass();
        editableControl.attrName = column.attrName;
        editableControl.enabled = false; //předejde se tak možnosti editovat hodnotu dříve než to povolí práva
        editableControl.multiline = column.multiLine;
        const data = this._getDataFromSet(dataSet);
        if (data !== undefined)
            editableControl.value = AttrValueReader.read(data);

        // listenery je potřeba vždy po přidání do DOMu znovu zaregistrovat
        editableControl.afterAttach(() => {
            editableControl.registerEventListener("change", (e: CustomEvent) => {
                e.stopPropagation();
                logger.log(`Element '${(e.target as Element).tagName}' is changed`);
                ElementUtils.callEvent(parentItem, "valuechanged", { value: editableControl.value, column: this.parentColumn });
            });
        });
        editableControl.isEditing = true;

        return { element: editableControl as HTMLElement, validatableControl: editableControl };
    }
}
